module.exports = __webpack_public_path__ + "img/612.eadb75d7.jpg";